
export default {
    'common.auto.height': '自动高度',
    'common.custom': '自定义',
    'common.default.name': '默认名称',
    'common.width': '宽',
    'common.height': '高',
    'common.close': '关闭',
    'common.setting': '设置',
    'common.switch.open': '开',
    'common.switch.close': '关',
    'common.panel': '面板',
    'common.layout': '布局',
    'common.basics': '基础',
    'common.attr': '属性',
    'common.content': '内容',
    'common.paper': '纸张',
    'common.unit': '单位',
    'common.font.size.unit': '字体单位',
    'common.show': '显示',
    'common.hidden': '隐藏',
    'common.xy': '坐标(x/y)',
    'common.position': '位置',
    'common.place.select': '请选择',

    'common.business.widget': '业务字段',
    'common.common.widget': '公共组件',
    'common.show.element.design.border': '显示元素边界',
    'common.panel.minimap.zoom.in': '放大',
    'common.panel.minimap.zoom.out': '缩小',
    'common.panel.minimap.navigation': '导航',
    'common.save.success': '保存成功',
    'common.save.fail': '保存失败',

    'common.auto': '自动',
    'common.fixed': '固定',
    'common.local.upload': '本地上传',
    'common.image.url': '图片链接',

    'common.text': '文本',
    'common.barcode': '条形码',
    'common.qrcode': '二维码',
    'common.dotted': '点',
    'common.dashed': '线',
    'common.operation.history': '历史操作',
    'common.mini.map': '小地图',
    'common.qr.errorCorrectionLevel.low': '低',
    'common.qr.errorCorrectionLevel.medium': '中等',
    'common.qr.errorCorrectionLevel.quartile': '四分之一',
    'common.qr.errorCorrectionLevel.high': '高',
};
